// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { appReducer } from 'store/behaviors/loader';
import capabilities from './capabilities';
import initialState from './grid';

const slice = createSlice({
    name: 'ticketType',
    initialState,
    reducers: {
        ...appReducer(capabilities)
    }
});

export default slice.reducer;

export const ticketTypeActions = slice.actions;
